export default __webpack_public_path__ + "static/media/Prime_0.73924566.png";